"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.ShareLink = void 0;
var React = require("react");
var styles = require("../styles/ShareLinkStyle");
var widgets_1 = require("@tableau/widgets");
var ClipboardUtils_1 = require("../utils/ClipboardUtils");
var GrayCopyLinkIcon_1 = require("../img/GrayCopyLinkIcon");
var Localize_1 = require("../../gen-src/Localize");
var TelemetryService_1 = require("../utils/TelemetryService");
var typestyle_1 = require("typestyle/");
var WhiteCopyLinkIcon_1 = require("../img/WhiteCopyLinkIcon");
var shareLinkInputClassName = typestyle_1.style({ width: '100%', });
var ShareLink = /** @class */ (function (_super) {
    __extends(ShareLink, _super);
    function ShareLink() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.inputElement = null;
        _this.handleInputRef = function (element) {
            _this.inputElement = element;
        };
        _this.handleClick = function () {
            TelemetryService_1.TelemetryService.Instance.log(TelemetryService_1.ShareDialogUserActionOptions.CopyLink);
            var text = _this.props.shareLink;
            var successMessage = Localize_1.Messages.linkCopiedNotificationText({ CONTENT_NAME: _this.props.contentName });
            ClipboardUtils_1.ClipboardUtils.copyUrlToClipboard(text, successMessage);
            if (_this.inputElement) {
                _this.inputElement.focus();
                _this.inputElement.setSelectionRange(0, _this.inputElement.value.length, 'backward');
            }
        };
        _this.getInputElement = function () {
            return _this.inputElement;
        };
        return _this;
    }
    ShareLink.prototype.render = function () {
        var CopyLinkIcon = this.props.isNamedSharingEnabled ? GrayCopyLinkIcon_1.GrayCopyLinkIcon : WhiteCopyLinkIcon_1.WhiteCopyLinkIcon;
        return React.createElement("div", { id: ShareLink.CONTAINER_ID },
            React.createElement("div", { style: styles.container },
                React.createElement("div", { style: styles.inputContainer },
                    React.createElement(widgets_1.TextFieldWidget, { className: shareLinkInputClassName, kind: 'outline', label: Localize_1.Messages.linkSharingLabel(), onChange: function () { }, readOnly: false, ref: this.handleInputRef, style: styles.input, testId: ShareLink.INPUT_ID, value: this.props.shareLink })),
                React.createElement(widgets_1.ButtonWidget, { buttonType: this.props.isNamedSharingEnabled ? widgets_1.ButtonType.Outline : widgets_1.ButtonType.Primary, onClick: this.handleClick, style: this.props.isNamedSharingEnabled ? styles.primaryButton : styles.button, testId: ShareLink.BUTTON_ID, title: Localize_1.Messages.copyLinkButtonTitle() },
                    React.createElement("span", { style: styles.buttonSpan },
                        React.createElement(CopyLinkIcon, { style: styles.icon, "aria-hidden": true }),
                        Localize_1.Messages.copyLink()))));
    };
    ShareLink.prototype.componentDidMount = function () {
        if (this.inputElement && !this.props.isNamedSharingEnabled) {
            // Initially select the text "backward", so the beginning of the link is shown.
            // Also, this selection should be done only when Named Sharing is not enabled,
            // to prevent ShareLink from stealing focus (TFSID 1009875)
            this.inputElement.setSelectionRange(0, this.inputElement.value.length, 'backward');
        }
    };
    ShareLink.BUTTON_ID = 'copy-link-button';
    ShareLink.CONTAINER_ID = 'copy-link-container';
    ShareLink.INPUT_ID = 'copy-link-input';
    return ShareLink;
}(React.PureComponent));
exports.ShareLink = ShareLink;
//# sourceMappingURL=ShareLink.js.map